module.exports = __webpack_public_path__ + "img/k.e8470897.jpg";